import Icon from '@mui/icons-material/Payments'

export default {
  name: 'payment-actions',
  options: {
    defaultSort: { field: 'created_on', order: 'DESC' },
  },
  icon: Icon,
}
